import { parselinkConfigurator } from "../helpers/hooks/helpers/helpers.js";
import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachCartConfiguration = () => {
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  const cartConfigurationContent = getBrPageContent(
    page,
    pageModels?.cartConfiguration
  );
  if (!cartConfigurationContent) {
    console.warn(
      `Cannot find main content for Cart Configuration. Got: ${cartConfigurationContent} for $ref: ${pageModels?.cartConfiguration?.$ref}`
    );
    return void 0;
  }
  const { title, description, linkConfigurator1, linkConfigurator2, policyItem } = cartConfigurationContent;
  const firstLink = parselinkConfigurator(linkConfigurator1, page);
  const secondLink = parselinkConfigurator(linkConfigurator2, page);
  const policyItems = policyItem && policyItem?.length > 0 ? policyItem?.map(
    ({ text, url, popupConfig: { content, title: title2 }, icon }) => ({
      text,
      url,
      popupConfig: { content, title: title2 },
      icon
    })
  ) : void 0;
  return {
    title,
    description,
    firstLink,
    secondLink,
    policyItems
  };
};
export {
  useBloomreachCartConfiguration
};
//# sourceMappingURL=use-bloomreach-cart-configuration.js.map
